import { apiInstances } from '../../../../libs';

const { get } = apiInstances.orderInstance;

export default async function getOrdersToPickup({
  page,
  filter,
  id_warecloud,
}) {
  const response = await get(
    `/clouders/orders/pickup-from-warecloud?filter=${filter}&id_warecloud=${id_warecloud}`
  );

  return response;
}
